import script from "./AccordionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionItem.vue?vue&type=script&setup=true&lang=js"

import "./AccordionItem.vue?vue&type=style&index=0&id=47aa32f5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47aa32f5"]])

export default __exports__